import * as React from "react";
import { addDays, endOfDay, startOfDay, format } from "date-fns";
import { DateRange } from "react-day-picker";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface DateRangePickerProps {
  dateRange: DateRange | undefined;
  onDateRangeChange: (range: DateRange | undefined) => void;
  className?: string;
}

export function DateRangePicker({
  dateRange,
  onDateRangeChange,
  className,
}: DateRangePickerProps) {
  const [selectedPeriod, setSelectedPeriod] = React.useState<string>("7days");

  const handlePeriodChange = (period: string) => {
    setSelectedPeriod(period);
    const today = new Date();
    
    switch (period) {
      case "7days":
        onDateRangeChange({
          from: startOfDay(addDays(today, -6)),
          to: endOfDay(today),
        });
        break;
      case "10days":
        onDateRangeChange({
          from: startOfDay(addDays(today, -9)),
          to: endOfDay(today),
        });
        break;
      case "30days":
        onDateRangeChange({
          from: startOfDay(addDays(today, -29)),
          to: endOfDay(today),
        });
        break;
    }
  };

  const getPeriodLabel = (period: string) => {
    switch (period) {
      case "7days":
        return "Últimos 7 dias";
      case "10days":
        return "Últimos 10 dias";
      case "30days":
        return "Último mês";
      default:
        return "Selecionar período";
    }
  };

  const getDateRangeText = () => {
    if (!dateRange?.from || !dateRange?.to) return "Nenhuma data selecionada";
    return `${format(dateRange.from, "dd/MM/yyyy")} - ${format(dateRange.to, "dd/MM/yyyy")}`;
  };

  return (
    <div className={cn("flex flex-col gap-3", className)}>
      <div className="flex gap-2">
        <Button
          variant={selectedPeriod === "7days" ? "default" : "outline"}
          size="sm"
          onClick={() => handlePeriodChange("7days")}
          className="text-sm"
        >
          7 dias
        </Button>
        <Button
          variant={selectedPeriod === "10days" ? "default" : "outline"}
          size="sm"
          onClick={() => handlePeriodChange("10days")}
          className="text-sm"
        >
          10 dias
        </Button>
        <Button
          variant={selectedPeriod === "30days" ? "default" : "outline"}
          size="sm"
          onClick={() => handlePeriodChange("30days")}
          className="text-sm"
        >
          1 mês
        </Button>
      </div>
      <div className="text-sm text-muted-foreground">
        {getPeriodLabel(selectedPeriod)} • {getDateRangeText()}
      </div>
    </div>
  );
}